import { render } from "./UpdateDepositView.vue?vue&type=template&id=c8bb880e&scoped=true"
import script from "./UpdateDepositView.vue?vue&type=script&lang=js"
export * from "./UpdateDepositView.vue?vue&type=script&lang=js"

import "./UpdateDepositView.vue?vue&type=style&index=0&id=c8bb880e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8bb880e"]])

export default __exports__